"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M18 19a2 2 0 0 0 2-2V7a2 2 0 1 0-4 0v10a2 2 0 0 0 2 2m-6 0a2 2 0 0 0 2-2v-7a2 2 0 1 0-4 0v7a2 2 0 0 0 2 2m-4-2a2 2 0 1 1-4 0v-4a2 2 0 1 1 4 0z"
}), 'ConversionFilled');
